import React from 'react';
import {useOutlet} from 'reconnect.js';
import styled from 'styled-components';
import Carousel from '../../../Components/Carousel';
import ProductItem from './ProductItem';

function ProductSection(props) {
  let {products} = props;
  const [dimension] = useOutlet('dimension');

  function restructureData(data) {
    let resultValue = [];
    let rowItems =
      dimension.innerWidth >= 768
        ? 4
        : dimension.innerWidth >= 550
        ? 3
        : dimension.innerWidth >= 480
        ? 2
        : 1;

    if (Array.isArray(data) && data.every((d) => !!d)) {
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          resultValue.push([data[i]]);
        }

        if (i !== 0) {
          if (i % rowItems === 0) {
            resultValue.push([data[i]]);
          } else {
            resultValue[resultValue.length - 1].push(data[i]);
          }
        }
      }
    }

    return resultValue;
  }

  return (
    <Wrapper>
      <div className="title-container">
        <h2>好好選品</h2>
        <h3>Featured</h3>
      </div>
      <div className="container">
        <Carousel
          autoSwipeDuration={5000}
          width={dimension.innerWidth >= 1200 ? 1200 : dimension.innerWidth}
          height={380}
          data={restructureData(products)}
          renderPrev={null}
          renderNext={null}
          disableSwipe={true}
          renderItem={({item, dimension, swipeStateRef}) => (
            <SlideItem
              item={item}
              dimension={dimension}
              swipeStateRef={swipeStateRef}
            />
          )}
          renderDots={null}
        />
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: 40px;

  & > .container {
    max-width: calc(1200px + 40px);
    width: 100%;
    margin: 0 auto;
    padding: 20px;

    @media screen and (max-width: 1200px) {
      padding: 0px;
    }
  }
`;

function SlideItem(props) {
  const {item, dimension, swipeStateRef} = props;
  const {width, height} = dimension;

  return (
    <SlideWrapper
      width={width}
      height={height}
      href={item.path}
      draggable={false}
      rel="noreferrer"
      target="_blank">
      {item.map((product, index) => (
        <ProductItem key={`product-${index}`} product={product} />
      ))}
    </SlideWrapper>
  );
}

const SlideWrapper = styled.a`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  position: relative;
  display: flex;
  justify-content: space-around;
`;

export default ProductSection;
